import {
  BANKS,
  BILLING_FREQUENCY,
  CARD_HOLDER_RELATIONSHIPS,
  ETR_STATUS_THAI,
  PAYMENT_MEHOD,
  UL_PREFIX
} from '../constants'
import dayjs from 'dayjs'
import buddhistEra from 'dayjs/plugin/buddhistEra'
import { AgentModel } from '../models/agent'
import { PaymentMethodModel } from '../models/paymentMethod'
import { MapCreditCardType } from '../constants/paymentDetail'
dayjs.extend(buddhistEra)

export const DisplayStatusName = (key: string | undefined) => {
  if (!key) return ''
  const result = ETR_STATUS_THAI.filter((item: any) => {
    return item.id === key
  })
  return result[0].Desc
}

export const getBillingFrequency = (key: string | undefined) => {
  if (!key) return ''
  const result = BILLING_FREQUENCY.filter((item: any) => {
    return item.id === key
  })
  return result[0].Desc
}

const removeTime = (date: Date) => {
  const data = date.toString().split('.')[0]
  // console.log(data)
  // console.log(dayjs(data).format('DD/MM/BBBB'))
  return data
}

export const DisplayToThaiDateFormat = (data: Date) => {
  if (!data) return data

  return dayjs(removeTime(data)).format('DD/MM/BBBB')
}

export const DisplayToThaiDateFormatFromString = (data: string | null | undefined) => {
  if (!data) return data
  if (data.length == 0) return ''

  return DisplayToThaiDateFormat(new Date(data))
}

export const DisplayStringDateToThaiDateFormat = (data: string) => {
  if (!data) return data

  return dayjs(data).format('DD/MM/BBBB')
}

export const DisplayDateToThaiDateFormat = (data: Date | undefined) => {
  if (!data) return data

  return dayjs(data).format('DD/MM/BBBB')
}

export const DisplayDateFormat = (data: Date | undefined) => {
  if (!data) return ''
  return dayjs(data).format('DD/MM/YYYY')
}

export const DisplayDateReportFormat = (data: Date | undefined) => {
  if (!data) return ''
  return dayjs(removeTime(data)).format('DD/MM/YYYY HH:mm:ss')
}

export const DisplayDateReportFormatNoTime = (data: Date | undefined) => {
  if (!data) return ''
  return dayjs(removeTime(data)).format('DD/MM/YYYY')
}

export const ConvertToSearchDateFormat = (data: string) => {
  if (/\d\d%2F\d\d%2F\d\d\d\d/.test(data)) {
    const result = data.split('%2F')
    return `${+result[2] - 543}-${result[1]}-${result[0]}`
  }

  return data
}

export const ConvertDateFormat = (data: string) => {
  if (/\d\d\/\d\d\/\d\d\d\d/.test(data)) {
    const result = data.split('/')
    return `${+result[2] - 543}-${result[1]}-${result[0]}`
  }

  return data
}

export const ReportDateFormat = (data: Date | undefined) => {
  if (!data) return ''
  return dayjs(data).format('YYYY-MM-DD')
}

export const maskingEmail = (email: string) => {
  if (!email || email?.length == 0 || email?.indexOf?.('@') < 0) {
    return ''
  }

  const mail = email.split('@')[0]
  const arr = []
  let result = mail[0]
  for (let i = 1; i < mail.length - 2; i++) {
    result += '*'
  }
  result += mail[mail.length - 1]
  arr.push(result)
  arr.push(email.split('@')[1])
  return arr.join('@')
}

export const replaceAt = (data: string, index: number, replacement: string) => {
  if (index >= data.length) {
    return data.valueOf()
  }

  return data.substring(0, index) + replacement + data.substring(index + 1)
}

export const maskingMobileNo = (mobileNo: string) => {
  if (!mobileNo || mobileNo?.length == 0 || mobileNo?.length != 10) {
    return ''
  }

  let result = mobileNo
  for (let i = 0; i < 6; i++) {
    result = replaceAt(result, i, '*')
  }
  return result
}

export const isMaskingData = (
  agentInfo: AgentModel,
  agentId: string,
  agentIds: string[] | undefined
): boolean => {
  let result = false
  if (agentId === undefined || agentId === null) return false
  if (agentIds != undefined || agentIds != null) {
    return !agentIds.includes(agentId)
  }
  if (agentInfo.agentId != agentId && !agentInfo.isBranchStaff) {
    result = true
  }
  return result
}

export const isULPolicy = (policyNo: string): boolean => {
  if (policyNo.length < 3) return false
  const policyPrefix = policyNo.substring(0, 2).toUpperCase()
  return UL_PREFIX.includes(policyPrefix)
}
export const hideCashPayment = (
  payType: number,
  policyNo: string,
  productGroup?: string
): string => {
  if (payType === 1 && isULPolicy(policyNo)) return 'none'
  if (payType === 1 && productGroup === 'UL') return 'none'
  return 'block'
}

export const getBankName = (bankCode?: string): string => {
  if (bankCode?.length == 0) return ''
  const filteredBanks = BANKS.filter((bank: { BANKCD: string }) => bank.BANKCD === bankCode)
  return filteredBanks.map((bank: { BANKNAME: any }) => bank.BANKNAME)
}

export const getCreditCardRelationship = (code?: string): string | null => {
  if (code?.length == 0) return ''
  const filteredItem = CARD_HOLDER_RELATIONSHIPS.find(
    (item: { code: string | undefined }) => item.code === code
  )
  //console.log('filtered', filteredItem.name)
  return filteredItem ? filteredItem.name : null
}

export const getPaymentMethod = (id: number): PaymentMethodModel => {
  return PAYMENT_MEHOD.find((obj: { id: number }) => obj.id === id)
}

export const getCreditCardName = (type: string) => {
  const name = MapCreditCardType[type as keyof typeof MapCreditCardType]

  if (name) {
    return name
  }

  return type
}
